var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConfidense(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 107 107",
    style: {
      enableBackground: "new 0 0 107 107"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#D9EEF7;}\r\n\t.st1{fill:#4C5B66;}\r\n\t.st2{fill:#31E8BB;}\r\n\t.st3{fill:#B71D1D;}\r\n")), /*#__PURE__*/React.createElement("image", {
    style: {
      display: "none",
      overflow: "visible"
    },
    width: 256,
    height: 256,
    xlinkHref: "../../../../../../../../manish/FlightAMS/PSD/flavours/strawberry/assets/user.png",
    transform: "matrix(1.6 0 0 1.6 -157.5 -155.5)"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.4,106l0.3-19.6c0,0,0.2-4.7,4.1-7.8c0,0,16.4-8.1,25.2-11.5c0,0,14.5-4.2,28,0.5c0,0,12.3,4.7,20.9,8.8 c0,0,7.1,4.2,7.4,9.3l0.2,20.3H11.4z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.3,63.4h-5.5c-9.1,0-16.5-7.4-16.5-16.5V28.1c0-9.1,7.4-16.5,16.5-16.5h5.5c9.1,0,16.5,7.4,16.5,16.5v18.8 C73.8,55.9,66.4,63.4,57.3,63.4z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M71.4,56.1l-2.3-2.4c2.9-2.8,4.1-9.2,4.3-11.5V27.3c-1.8-12.2-12.6-15.1-13.1-15.2c-4-1-10.2-0.2-11.3,0 c-13.8,5.5-13.4,15.6-13.4,15.7l0,0.1v15.8c0,3.3,3.4,8.5,4.7,10.2l-2.7,2c-0.5-0.7-5.4-7.3-5.4-12.2V27.9c0-0.5-0.1-3.5,1.7-7.2 c1.7-3.6,5.5-8.5,13.9-11.8L48,8.8l0.2,0c0.3-0.1,7.8-1.2,12.9,0c0.1,0,3.5,0.9,7,3.5c3.3,2.5,7.5,7,8.6,14.6l0,0.1l0,15.3 C76.6,42.8,75.8,51.9,71.4,56.1z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "63.1,106 63.1,101.9 63.1,73.6 68.1,73.6 55.1,54.6 41.3,73.6 46.6,73.7 46.6,106 46.6,106  "
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13.8,106h-3.3V85.9l0-0.1c1.1-6.7,6.6-9.7,6.9-9.8l0,0L30,69.7l1.5,3l-12.6,6.2c-0.3,0.2-4.2,2.4-5.1,7.3V106 z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 26.5,
    y: 87.6,
    className: "st1",
    width: 3.3,
    height: 18.4
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 79.3,
    y: 87.6,
    className: "st1",
    width: 3.3,
    height: 18.4
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96.2,106l-0.6-19.4l0,0c0.1-3.5-4-6.9-5.7-8.1L78,72.7l1.5-3l12,5.9l0.1,0.1c0.3,0.2,7.4,4.9,7.3,11l0.6,19.4 L96.2,106z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "64.2,97.6 60.9,97.6 60.9,73.7 67.9,73.7 55.2,54.5 41.4,73.6 48,73.7 48,97.6 44.6,97.6 44.6,77  34.9,76.9 55.3,48.6 74.2,77 64.2,77  "
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 52.9,
    y: 73.3,
    className: "st1",
    width: 3.3,
    height: 20.3
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 52.9,
    y: 97.6,
    className: "st1",
    width: 3.3,
    height: 4.3
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M21.2,107"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 44.3,
    y: 101.9,
    className: "st1",
    width: 3.3,
    height: 4.1
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 101.9,
    className: "st1",
    width: 3.3,
    height: 4.1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfidense);
export default __webpack_public_path__ + "static/media/confidense.06b13a265f463fd2532b1310b52b1a57.svg";
export { ForwardRef as ReactComponent };